import script from "./RegisterModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterModal.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterModal.vue?vue&type=style&index=0&id=34ebde55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ebde55"]])

export default __exports__